import { mapActions, mapState } from 'vuex';
import { currencyFilter } from '@/utils/filters.js';
import { LEAD_TYPES, INVITATION_STATUS, USER_TYPE } from '@/utils/constants';
import { createOccupation } from '@/services';

import PaymentChoice from '@/components/supplier/offer-details/modal/payment-choice';
export default {
    name: 'AcquisitionModal',
    LEAD_TYPES: LEAD_TYPES,
    components: {
        PaymentChoice
    },
    props: {
        show: Boolean,
        width: String,
        height: String,
        isMobile: Boolean,
        competition: Object,
        supplierDiscount: Number,
        calculateSupplierDiscount: Number,
        wallet: Object,
        fromMeeting: Boolean,
        subscription: Object
    },
    data: () => ({
        showBanner: true,
        loading: false,
        paymentMethod: '',
        acceptTerms: false,
        meetingId: 0
    }),
    methods: {
        currencyFilter,
        ...mapActions('notification', ['showNotification']),
        ...mapActions('payment', ['setPaymentCheckout', 'setFromMeetingCheckout']),
        ...mapActions('router', ['setRedirectUrl']),
        ...mapActions('user', ['setSubscriptionHeader']),
        openBalancePurchase() {
            this.$router.push({ name: 'BalancePurchase' });
        },
        openMessage() {
            this.showNotification({ text: 'Compra realizada com sucesso!', type: 'success' });
            this.$emit('close', false);
        },
        async createOccupation() {
            this.loading = true;
            try {
                if (this.paymentMethod.length) {
                    const value = this.paymentChoice.find(({ value }) => {
                        return value == this.paymentMethod;
                    }).value;
                    const status = this.paymentChoice.find(({ value }) => {
                        return value == this.paymentMethod;
                    }).status;
                    const payload = {
                        competition: this.competition.id,
                        from_meeting: this.fromMeeting,
                        status: status,
                        payment_type: this.paymentMethod,
                        transaction_id: this.paymentMethod
                    };
                    const { token } = await createOccupation(payload);
                    if (value == LEAD_TYPES.CREDIT_CARD) {
                        if (this.fromMeeting) {
                            this.setFromMeetingCheckout(this.meetingId);
                        } else {
                            this.setPaymentCheckout({
                                token,
                                competitionId: this.competition.nextSlot.id
                            });
                        }
                        this.setRedirectUrl(this.$route.fullPath);
                        return this.$router.push({ name: 'Checkout' });
                    }
                    this.$emit('close', false);
                    this.showNotification({ text: 'Compra realizada com sucesso!', type: 'success' });
                    this.setSubscriptionHeader();
                    this.$emit('initializeData', true);
                } else {
                    this.$emit('close', false);
                    this.showNotification({ text: 'Método de pagamento não indentificado', type: 'error' });
                }
            } catch (error) {
                this.$emit('close', false);
                this.showNotification({ text: error, type: 'error' });
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        ...mapState('user', ['supplierData']),
        contractorType() {
            if (
                this.competition.contractorTypeKey === USER_TYPE.REQUESTER ||
                this.competition.contractorTypeKey === USER_TYPE.CONDO_ADMINISTRATOR ||
                this.competition.contractorTypeKey === USER_TYPE.PROFESSIONAL_BUILDING_MANAGER
            ) {
                return 'Condomínio';
            } else if (this.competition.contractorTypeKey === USER_TYPE.PRIVATE_PERSON) {
                return 'Cliente Engelink';
            } else {
                return this.competition.contractorTypeValue;
            }
        },
        iconTitle() {
            const obj = {
                'Construção civil': 'hard-hat.svg',
                contractor_type: 'hard-hat.svg',
                'Cliente Engelink': 'house.svg',
                'Pessoa Física': 'house.svg',
                Corporativo: 'business.svg',
                Condomínio: 'building.svg',
                Solicitante: 'building.svg',
                Administradora: 'building.svg',
                'Síndico(a) profissional': 'building.svg'
            };
            return require('@/assets/images/' + obj[this.competition.contractorTypeValue]);
        },
        disabledBtn() {
            if (this.competition.isBpo) {
                if (this.paymentMethod.length > 0 && this.acceptTerms) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return !this.paymentMethod.length > 0;
            }
        },
        canBuyQuotationCreditCard() {
            return this.supplierData.canBuyQuotationCreditCard;
        },
        paymentChoice() {
            return [
                {
                    name: 'Utilizar Crédito',
                    value: LEAD_TYPES.PANEL_CREDIT,
                    status: INVITATION_STATUS.PANEL_CREDIT_CONSUMED,
                    active: this.canUseCredits,
                    icon: 'fa-money-check-alt'
                },
                {
                    name: 'Utilizar Bônus',
                    value: LEAD_TYPES.BONUS_PANEL,
                    status: INVITATION_STATUS.PANEL_BONUS_CASH_CONSUMED,
                    active: this.wallet.bonusCash >= this.calculateSupplierDiscount && this.wallet.canUseBonus,
                    icon: 'fa-award'
                },
                {
                    name: 'Utilizar Moedas',
                    value: LEAD_TYPES.BALANCE,
                    status: INVITATION_STATUS.PANEL_LEAD_CASH_CONSUMED,
                    active: this.wallet.engelinkCash >= this.calculateSupplierDiscount,
                    icon: 'fa-coins'
                },
                // {
                //     name: 'Utilizar Cartão de Crédito',
                //     value: LEAD_TYPES.CREDIT_CARD,
                //     status: INVITATION_STATUS.PAYMENT_VISUALIZED,
                //     active: this.canBuyQuotationCreditCard,
                //     icon: 'fa-credit-card'
                // }
            ];
        },
        paymentReleased() {
            return (
                this.canBuyQuotationCreditCard ||
                this.wallet.engelinkCash >= this.calculateSupplierDiscount ||
                this.wallet.bonusCash >= this.calculateSupplierDiscount ||
                this.wallet.canUseBonus ||
                this.canUseCredits
            );
        },
        canUseCredits() {
            if (this.competition.nextSlot.forSubscribers) {
                return this.subscription.canUsedCreditInSpecialCompetition;
            } else {
                return !this.competition.nextSlot.forSubscribers && this.subscription.canUsedCreditInCompetition;
            }
        },
        cssProps() {
            return {
                '--acquisitionBannerText': this.isMobile ? '9px' : '11px',
                '--acquisitionInfosGrid': this.isMobile ? 'row' : 'flex',
                '--borderBtnEnable': this.disabledBtn || this.loading ? 'none' : 'solid 1px #007bff'
            };
        }
    }
};
